import React from 'react';

interface ChatInfoProps {
  last_message_text: string;
  name: string;
  is_seen: boolean;
}
const ChatInfo = ({last_message_text, name, is_seen}: ChatInfoProps) => {
  return (
    <div className="flex flex-col w-[80%] justify-center gap-4">
      <p className="w-full flex  text-gray-2 text-[16px]  font-medium">
        {name}
      </p>
      <div className="flex justify-between  w-full text-brand-2 font-medium	">
        <div className="flex !text-[14px] justify-center gap-2 items-center">
          {is_seen && (
            <span className="icon-seen w-[14px] h-[14px] flex text-[10px]" />
          )}
          <span className="   w-full text-[14px] overflow-hidden max-w-[156px] truncate">
            {last_message_text}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ChatInfo;
